import { render } from "./KeyWordsForm.vue?vue&type=template&id=73a3a970&ts=true"
import script from "./KeyWordsForm.vue?vue&type=script&lang=ts"
export * from "./KeyWordsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__